import { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuth } from '../../hooks/use-auth'
import { Navbar } from './Navbar'
import { HeroSection } from './HeroSection'
import { CapabilitiesSection } from './CapabilitiesSection'
import { HowItWorksSection } from './HowItWorksSection'
import { ValuePropSection } from './ValuePropSection'
import { UseCasesSection } from './UseCasesSection'
import { CTASection } from './CTASection'
import { Footer } from './Footer'

export default function LandingPage() {
  const [isScrolled, setIsScrolled] = useState(false)
  const { user, isLoggedIn, isAdmin, logout } = useAuth()
  const navigate = useNavigate()

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 50)
    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
  }, [])

  const handleStart = () => {
    if (isLoggedIn) {
      navigate('/workspace')
    } else {
      navigate('/login?mode=register')
    }
  }

  const handleLogout = () => {
    logout()
    navigate('/')
  }

  return (
    <div
      className="min-h-screen"
      style={{
        background: 'linear-gradient(180deg, #f5f3ff 0%, #f0efff 14%, #f5f0ff 28%, #f0f0ff 42%, #f5f0ff 52%, #fff7ed 62%, #fef3e2 75%, #fdf2e9 88%, #fdf2e9 100%)',
      }}
    >
      <style>{`
        html {
          scroll-snap-type: y proximity;
          scroll-behavior: smooth;
        }
      `}</style>
      <Navbar
        isScrolled={isScrolled}
        isLoggedIn={isLoggedIn}
        isAdmin={isAdmin}
        user={user}
        onLogout={handleLogout}
      />

      <HeroSection isLoggedIn={isLoggedIn} onStart={handleStart} />
      <CapabilitiesSection />
      <HowItWorksSection />
      <ValuePropSection />
      <UseCasesSection />
      <CTASection isLoggedIn={isLoggedIn} onStart={handleStart} />
      <Footer />
    </div>
  )
}
